/**
 * ItemGo Service Man with a Van — Pricing Engine
 *
 * Customer selects vehicle type. Pricing = hourly rate (per vehicle) + mileage.
 * All values in pence (GBP). VAT on (servicePrice + serviceFee).
 * Everything configurable from Firestore pluginConfigs/{serviceId}.
 */
export const DEFAULT_MANWITHVAN_PRICING_CONFIG = {
    serviceFee: 599, // £5.99
    vatRate: 0.20, // 20%
    vehicleHourlyRates: {
        van_s: 2500, // £25.00/hr
        van_m: 3000, // £30.00/hr
        van_l: 3500, // £35.00/hr
        van_xl: 4000, // £40.00/hr
        luton: 5000, // £50.00/hr
    },
    helperRate: 1500, // £15.00 per helper per hour
    fuelSurchargePerMile: 50, // £0.50 per mile
    minHours: 2,
    waitingRatePerHour: 2500, // £25.00/hr
};
export function calculateManWithVanPricing(input) {
    const config = input.config;
    const vehicleType = input.vehicleType || 'van_s';
    const hourlyRate = config.vehicleHourlyRates[vehicleType] ?? config.vehicleHourlyRates.van_s;
    const hours = Math.max(input.hours, config.minHours);
    const helpers = input.helpers || 0;
    const distanceMiles = input.distanceMiles || 0;
    const hourlyCharge = hours * hourlyRate;
    const helperCharge = hours * helpers * config.helperRate;
    const fuelCharge = Math.round(distanceMiles * config.fuelSurchargePerMile);
    const servicePrice = hourlyCharge + helperCharge + fuelCharge;
    const serviceFee = config.serviceFee ?? 599;
    const vatRate = config.vatRate ?? 0.20;
    const vatAmount = Math.round((servicePrice + serviceFee) * vatRate);
    const customerTotal = servicePrice + serviceFee + vatAmount;
    return {
        vehicleType,
        hourlyRate,
        hourlyCharge,
        helperCharge,
        fuelCharge,
        servicePrice,
        serviceFee,
        vatAmount,
        customerTotal,
        formatted: {
            hourlyRate: formatPence(hourlyRate),
            hourlyCharge: formatPence(hourlyCharge),
            helperCharge: formatPence(helperCharge),
            fuelCharge: formatPence(fuelCharge),
            servicePrice: formatPence(servicePrice),
            serviceFee: formatPence(serviceFee),
            vatAmount: formatPence(vatAmount),
            customerTotal: formatPence(customerTotal),
        },
    };
}
export function formatPence(pence) {
    return `£${(pence / 100).toFixed(2)}`;
}
//# sourceMappingURL=pricing.js.map